import styled from "styled-components";
import {
  CheckBox,
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import { useRef, useState } from "react";
import axios from "axios";
import url from "../../../../Component/server";
import { useNavigate } from "react-router-dom";

interface Step3Props {
  storeName: string;
  handleStoreName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accountNum: string;
  handleAccountNum: (e: React.ChangeEvent<HTMLInputElement>) => void;
  bank: string;
  handleBank: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accountHolder: string;
  handleAccountHolder: (e: React.ChangeEvent<HTMLInputElement>) => void;
  kakaoURL: string;
  handleKakaoURL: (e: React.ChangeEvent<HTMLInputElement>) => void;
  check1: boolean;
  check2: boolean;
  handleCheck1: () => void;
  handleCheck2: () => void;
  setStoreNameCheck: (value: boolean) => void;
}

const Step3 = ({
  storeName,
  handleStoreName,
  accountNum,
  handleAccountNum,
  bank,
  handleBank,
  accountHolder,
  handleAccountHolder,
  kakaoURL,
  handleKakaoURL,
  check1,
  check2,
  handleCheck1,
  handleCheck2,
  setStoreNameCheck,
}: Step3Props) => {
  const storeNameCheck = () => {
    const regex = /^[a-zA-Z0-9가-힣]{2,10}$/; // 영문, 숫자, 한글만 허용하며 길이는 2~10자
    if (storeName === "") {
      alert("스토어명을 입력해주세요.");
      return;
    }
    if (!regex.test(storeName)) {
      alert("스토어명은 영문, 숫자, 한글만 가능하며 2~10자로 입력해주세요.");
      return;
    }
    axios
      .get(url.Communication_url.store_name_dup_check, {
        params: { store_name: storeName },
      })
      .then((res) => {
        setStoreNameCheck(true);
        alert("사용 가능한 스토어명입니다.");
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message === "중복") {
          alert("이미 사용 중인 스토어명입니다.");
        }
      });
  };
  const Navigate = useNavigate();
  // const go_rule = () => Navigate("/rule/1");
  const go_rule = () => window.open("/rule/1", "_blank", "noopener,noreferrer");
  // const go_rule2 = () => Navigate("/rule/2");
  const go_rule2 = () =>
    window.open("/rule/2", "_blank", "noopener,noreferrer");

  return (
    <>
      <Title>
        스토어명 <span style={{ color: "red" }}>*</span>
      </Title>
      <StoreNameDiv>
        <StoreNameInsertDiv>
          <StoreNameInsert
            type="text"
            placeholder="스토어명을 입력해주세요."
            value={storeName}
            onChange={handleStoreName}
          />
        </StoreNameInsertDiv>
        <StoreNameCheckBtn onClick={storeNameCheck}>중복확인</StoreNameCheckBtn>
      </StoreNameDiv>
      <Title>
        계좌번호 <span style={{ color: "red" }}>*</span>
      </Title>
      <InsertDiv>
        <InsertInput
          type="text"
          placeholder="계좌번호를 입력해주세요."
          value={accountNum}
          onChange={handleAccountNum}
        />
      </InsertDiv>
      <RowView style={{ gap: 15 }}>
        <div style={{ flex: 1 }}>
          <Title>
            은행명 <span style={{ color: "red" }}>*</span>
          </Title>
          <InsertDiv>
            <InsertInput
              type="text"
              placeholder="은행명을 입력해주세요."
              value={bank}
              onChange={handleBank}
            />
          </InsertDiv>
        </div>
        <div style={{ flex: 1 }}>
          <Title>
            예금주명 <span style={{ color: "red" }}>*</span>
          </Title>
          <InsertDiv>
            <InsertInput
              type="text"
              placeholder="예금주명을 입력해주세요."
              value={accountHolder}
              onChange={handleAccountHolder}
            />
          </InsertDiv>
        </div>
      </RowView>
      {/* <Title>
        카카오톡 채널 URL <span style={{ color: "red" }}>*</span>
      </Title>
      <InsertDiv>
        <InsertInput
          type="text"
          placeholder="카카오톡 채널 URL을 입력해주세요."
          value={kakaoURL}
          onChange={handleKakaoURL}
        />
      </InsertDiv> */}
      <TermsDiv>
        <RowView>
          <RowView2>
            <CheckBox
              type={"checkbox"}
              checked={check1}
              readOnly
              onClick={handleCheck1}
            />
            [필수] 서비스 이용약관 동의
          </RowView2>
          <DetailBtn onClick={go_rule}>
            보기
            <Icon src={require("../../../../Image/ic_right_gray.png")} />
          </DetailBtn>
        </RowView>
        <RowView style={{ marginTop: 10 }}>
          <RowView2>
            <CheckBox
              type={"checkbox"}
              checked={check2}
              readOnly
              onClick={handleCheck2}
            />
            [필수] 개인정보 처리 방침 동의
          </RowView2>
          <DetailBtn onClick={go_rule2}>
            보기
            <Icon src={require("../../../../Image/ic_right_gray.png")} />
          </DetailBtn>
        </RowView>
      </TermsDiv>
    </>
  );
};

export default Step3;

const Title = styled.div`
  font-family: var(--font-Pretendard-Medium);
  margin-top: 30px;
`;

const InsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  margin-top: 10px;
`;

const InsertInput = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 화살표 제거 - Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

const EmailInsertDiv = styled.div<{ $disabled?: boolean }>`
  flex-direction: row;
  display: flex;
  background-color: ${(props) => (props.$disabled ? "#FBFBFB" : "transparent")};
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const Select = styled.div`
  position: relative;
  margin-top: 10px;
`;
const ItemBox = styled(RowView)`
  padding: 0.8rem 1rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  div.gray {
    color: #8e8e8e;
  }
  &.open {
    border-radius: 8px 8px 0px 0px;
    border-bottom: 0;
  }
`;
const ItemList = styled.div`
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 29rem;
  background-color: white;
  border-top: 0;
  border: 1px solid #f0f0f0;
  overflow: auto;
  cursor: pointer;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    &:hover {
      background: #ababab;
    }
  }
  div {
    padding: 0.8rem 1rem;
    border-top: 1px solid #f0f0f0;
    &:hover {
      background-color: #f8f8f8;
    }
  }
  &.open {
    display: block;
  }
`;

const StoreNameDiv = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const StoreNameInsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  flex: 7;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const StoreNameInsert = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const StoreNameCheckBtn = styled.div`
  cursor: pointer;
  background-color: black;
  height: 48px;
  border-radius: 8px;
  flex: 2;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  color: white;
`;
const TermsDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;

const DetailBtn = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #8e8e8e;
  cursor: pointer;
`;
